import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-511"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path d=\"M12.543 4.487c-1.581 0-3.876 1.712-4.57 2.888C7.282 6.2 4.987 4.487 3.406 4.487a3.486 3.486 0 0 0 0 6.97c1.58 0 3.876-1.75 4.569-2.906.693 1.156 2.988 2.906 4.569 2.906a3.486 3.486 0 0 0 0-6.97zm-9.138 5.97a2.486 2.486 0 0 1 0-4.97c1.309 0 3.462 1.745 3.762 2.476-.306.675-2.418 2.494-3.762 2.494zm9.138 0c-1.345 0-3.457-1.82-3.762-2.494.3-.73 2.452-2.476 3.762-2.476a2.486 2.486 0 0 1 0 4.97z\"></path><circle cx=\"2.989\" cy=\"2.481\" r=\"1\"></circle><circle cx=\"13\" cy=\"2.481\" r=\"1\"></circle><circle cx=\"2.989\" cy=\"13.457\" r=\"1\"></circle><circle cx=\"13\" cy=\"13.457\" r=\"1\"></circle>", 5)
const _hoisted_7 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_7))
}
export default { render: render }